module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
    'use strict';

    fox.registerWidget('Popup_CommunityName', {
        configure: function(options) {
            this.registerOptions('', {
                autoRender: true,
                template: 'popup_communityname',
                widgets: {
                    form: {
                        widget: 'DomForm',
                        formSelector: '.message-popup',
                        validateOnFly: true,
                        valuePostProcessing: [function (value) {
                            return window.escape(fox.trim(value));
                        }]
                    }
                },
                'handleWom.formValidate': {
                    event: ['form_not_valid', 'form_valid'],
                    widget: '#form',
                    callback: function (infos, form) {
                        var info = infos[0];
                        var field = this.dom1('[name=' + info.field + ']');

                        $(field)[info.result ? 'removeClass' : 'addClass']('error');
                    }
                },
                handleDom: {
                    clickSave: {
                        event: 'click',
                        target: '#save-communityName',
                        targetWidget: '@parent',
                        callback: 'save'
                    },
                    clickClose: {
                        event: 'click',
                        target: '#cancel-communityName',
                        targetWidget: '@parent',
                        callback: 'hide'
                    }
                },
                handleWom: {
                    communityNameSaved: {
                        widget: '@root #communityNameService',
                        event: 'community_nick_saved',
                        callback: function (value) {
                            this.rwom1('#form').setValue('communityName', fox.isEmpty(value) ? '' : value);
                        }
                    }
                }
            });

            this.callParent('configure', arguments);
        },

        save: function(btn) {
            var redirectUrl = this.getOption('redirectUrl');

            if (redirectUrl) {
                window.open(redirectUrl, '_blank');
            }

            this.rwom1('#form').submit().then(function (values) {
                $(btn).addClass('spin');

                if (values !== false) {
                    return this.rwom1('@root #communityNameService').setNick(values.communityName);
                }

                return values;
            }.bind(this)).then(function (resp) {
                $(btn).removeClass('spin');

                if (resp !== false)
                    this.hide();
            }.bind(this)).catch(function () {
                $(btn).removeClass('spin');
            });
        },

        hide: function() {
            this.getParent().hide();
        }

    });
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/popup/communityName.js
// module id = 342
// module chunks = 2